import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { HotTopic } from '@/types';
import { trackFeature } from '@/utils/adobeLaunch';
import { t } from '@/utils/i18n';
import { getDesignImageUrl } from '@/utils/imageUrls/getDesignImageUrl';
import { LoadingImage } from '@/components/common/LoadingImage';
import { LIST_ROUTE, addSearchTermToRoute } from './DesignSelector';
import './HotTopics.scss';

const topicImage = (designId: string) =>
  getDesignImageUrl(designId, {
    width: 120,
    height: 120,
    defaultImageOnError: false,
  });

type Props = {
  topics: HotTopic[];
};

export const HotTopics: FunctionComponent<Props> = ({ topics }) => {
  if (topics.length === 0) {
    return null;
  }

  return (
    <div className="hot-topics">
      <h4 className="hot-topics__headline">{t('designSelector.bestseller')}</h4>
      <ul>
        {topics.map((topic) => (
          <li
            style={{ backgroundColor: `#${topic.colorHex || 'cee2e0'}` }}
            key={topic.designId}
            role="menuitem"
          >
            <Link
              to={addSearchTermToRoute(LIST_ROUTE, topic.value)}
              className="hot-topic"
              onClick={() =>
                trackFeature('design-selection-hot-topic', { term: topic.value }, true)
              }
            >
              <LoadingImage src={topicImage(topic.designId)} alt="" className="hot-topic__image" />
              <h2 className="hot-topic__label">{topic.value}</h2>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
